import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';
import XLSX from 'sheetjs-style';

import { Card } from 'sa-ui';
import { indexOf } from 'lodash';
import messages from '../../reportsMessages';
import * as helpers from '../../reportHelpers';
import LoadMore from '../../LoadMore';

import StudentPerformanceSquare from '../../StudentPerformanceSquare';

import './GradeAbilitiesTable.scss';

const GradeAbilitiesTable = (props) => {
  const [limit, setLimit] = useState(props.expanded ? Infinity : props.limit);

  function exportXLSX(data) {
    const alphabet = ['A', 'B', 'C', 'D', 'E'];

    // Table header
    const tableHeader = [
      props.intl.formatMessage(messages.position),
      props.intl.formatMessage(messages.abilities),
      props.intl.formatMessage(messages.description),
      `${props.intl.formatMessage(messages.hitPercentage)}(%)`,
      props.intl.formatMessage(messages.curricularComponent),
    ];

    // Table content
    const tableContent = [];

    data.map((item, index) => {
      tableContent.push([
        `Q${item.position}`,
        item.contentAbility,
        item.abilityDescription,
        `${item.percentHits}%`,
        item.curricularComponent,
      ]);
    });

    const tableData = [tableHeader].concat(tableContent);

    const ws = XLSX.utils.aoa_to_sheet(tableData);

    const columnsWidth = [{ width: 0 }, { width: 0 }, { width: 0 }, { width: 0 }, { width: 0 }];

    // Header styles
    tableHeader.forEach((item, index) => {
      ws[`${alphabet[index]}1`].s = {
        font: { bold: true, color: { rgb: '8d8d8d' } },
        alignment: { horizontal: 'center' },
        border: {
          top: { style: 'thin', color: '00735e' },
          bottom: { style: 'thin', color: '00735e' },
          left: { style: 'thin', color: '00735e' },
          right: { style: 'thin', color: '00735e' },
        },
      };

      if (item.length > columnsWidth[index].width) {
        columnsWidth[index].width = item.length;
      }
    });

    // Content styles
    tableContent.forEach((row, rIdx) => {
      row.forEach((col, cIdx) => {
        const cellStyle = {
          border: {
            top: { style: 'thin', color: '00735e' },
            bottom: { style: 'thin', color: '00735e' },
            left: { style: 'thin', color: '00735e' },
            right: { style: 'thin', color: '00735e' },
          },
        };

        if (alphabet[cIdx] != 'C') {
          cellStyle.alignment = { horizontal: 'center' };

          if (alphabet[cIdx] === 'D') {
            let cellColor = helpers.getColor(col);
            cellColor = cellColor.replace('#', '').toLowerCase();

            cellStyle.font = { color: { rgb: 'ffffff' } };
            cellStyle.fill = { bgColor: { rgb: cellColor }, fgColor: { rgb: cellColor } };
            cellStyle.alignment = { horizontal: 'center' };
          }
        }

        // Adjust column width
        if (col.length > columnsWidth[cIdx].width) {
          columnsWidth[cIdx].width = alphabet[cIdx] === 'B' ? col.length + 5 : col.length;
        }

        ws[alphabet[cIdx] + (rIdx + 2)].s = cellStyle;
      });
    });

    ws['!cols'] = columnsWidth;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, props.intl.formatMessage(messages.sheetFilename));

    // Generate XLSX file and send to client
    const filename = `${props.intl.formatMessage(messages.sheetFilename)}_${
      props.idEvaluation
    }.xlsx`;

    XLSX.writeFile(wb, filename);
  }

  return (
    <Card className="students-grade-table">
      <div className="mb-4">
        <h5 className="title mt-0 pb-0 d-inline-block">
          <i className="ti ti-stats-up mr-2" />
          {props.intl.formatMessage(messages.hitPercentageAbilitiesPerQuestion)}
        </h5>
        {props.data && props.data.length > 0 && (
          <button
            className="btn btn-primary btn-sm float-right"
            onClick={() => exportXLSX(props.data)}
          >
            {props.intl.formatMessage(messages.generateSheet)}
          </button>
        )}
      </div>
      <div>
        <table className="default-table">
          <thead>
            <tr>
              <th>{props.intl.formatMessage(messages.position)}</th>
              <th>{props.intl.formatMessage(messages.abilities)}</th>
              <th>{props.intl.formatMessage(messages.hitPercentage)} (%)</th>
              <th>{props.intl.formatMessage(messages.curricularComponent)}</th>
            </tr>
          </thead>
          <tbody>
            {props.data.slice(0, limit).map((s, index) => (
              <tr>
                <td className="font-smaller">{`Q${s.position}`}</td>
                <td className="btn-abilities font-smaller">
                  {s.contentAbility && s.abilityDescription ? (
                    <OverlayTrigger
                      trigger="hover"
                      key={index}
                      placement="left"
                      overlay={
                        <Popover id="popover-positioned-left">
                          <Popover.Body>{s.abilityDescription}</Popover.Body>
                        </Popover>
                      }
                    >
                      <Button>{s.contentAbility}</Button>
                    </OverlayTrigger>
                  ) : (
                    '-'
                  )}
                </td>
                <td>
                  <StudentPerformanceSquare
                    percentHits={s.percentHits}
                    color={helpers.getColor(s.percentHits)}
                    size={50}
                  />
                </td>
                <td className="font-smaller">{s.curricularComponent}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!props.expanded && props.data.length > 10 && (
          <LoadMore onClick={() => setLimit(limit + props.limit)} />
        )}
      </div>
    </Card>
  );
};

GradeAbilitiesTable.propTypes = {};

GradeAbilitiesTable.defaultProps = {
  data: [],
  limit: 10,
  expanded: false,
};

export default injectIntl(GradeAbilitiesTable);
